// 合同管理
const contractManagementJurisdiction = [
  { id: '002001001', label: '添加合同', children: [] },
  { id: '002001002', label: '修改合同', children: [] },
  { id: '002001003', label: '提交合同', children: [] },
  { id: '002001004', label: '续租保存', children: [] },
  { id: '002001005', label: '续租保存并审批', children: [] },
  { id: '002001006', label: '续租提交审批', children: [] },
  { id: '002001007', label: '退租保存', children: [] },
  { id: '002001008', label: '退租保存并审批', children: [] },
  { id: '002001009', label: '退租提交审批', children: [] },
  { id: '002001010', label: '换租保存', children: [] },
  { id: '002001011', label: '换租修改', children: [] },
  { id: '002001012', label: '换租提交审批', children: [] },
  { id: '002001013', label: '合同复制保存', children: [] },
  { id: '002001014', label: '合同作废', children: [] },
  { id: '002001015', label: '合同下载', children: [] }
]

// 其他合约管理
const otherContractManagementJurisdiction = [
  { id: '002005001', label: '添加合约', children: [] },
  { id: '002005002', label: '修改合约', children: [] },
  { id: '002005003', label: '新增提交审批', children: [] },
  { id: '002005004', label: '续租保存', children: [] },
  { id: '002005005', label: '续租修改', children: [] },
  { id: '002005006', label: '续租保存并审批', children: [] },
  { id: '002005007', label: '退租保存', children: [] },
  { id: '002005008', label: '退租修改', children: [] },
  { id: '002005009', label: '退租提交审批', children: [] },
  { id: '002005010', label: '查看退租协议', children: [] },
  { id: '002005011', label: '合约作废', children: [] },
  { id: '002005015', label: '合约删除', children: [] }
]

// 其他合约账单管理
const otherBillManagementJurisdiction = [
  { id: '002006001', label: '导出', children: [] }
]

// 工商地址注册管理
const businessAddressRegistrationManagementJurisdiction = [
  { id: '002007001', label: '迁出', children: [] }
]

// 账单类型
const otherBillTypeManageJurisdiction = [
  { id: '002012001', label: '添加', children: [] },
  { id: '002012003', label: '删除', children: [] }
]

// 租金管理
const rentManagementJurisdiction = [
  { id: '002008001', label: '导出', children: [] }
]

// 物业费管理
const propertyManagementJurisdiction = [
  { id: '002009001', label: '导出', children: [] }
]

// 保证金管理
const depositManagementJurisdiction = [
  { id: '002010001', label: '导出', children: [] }
]

// 智慧合约
const investmentLeasingJurisdictionChildren = [
  {
    id: '002004000',
    label: '概览',
    routerName: 'investment-over-view',
    children: []
  },
  {
    id: '002001000',
    label: '合同列表',
    routerName: 'contract-management',
    children: contractManagementJurisdiction
  },
  {
    id: '002002000',
    label: '归档合同',
    routerName: 'filing-contract',
    children: []
  },
  {
    id: '002005000',
    label: '合约列表',
    routerName: 'other-contract-management',
    children: otherContractManagementJurisdiction
  },
  {
    id: '002011000',
    label: '归档合约',
    routerName: 'other-filing-contract',
    children: []
  },
  {
    id: '002006000',
    label: '账单管理',
    routerName: 'other-rent-management',
    children: otherBillManagementJurisdiction
  },
  {
    id: '002007000',
    label: '工商地址注册管理',
    routerName: 'business-address-registration',
    children: businessAddressRegistrationManagementJurisdiction
  },
  {
    id: '002012000',
    label: '账单类型',
    routerName: 'other-bill-type-manage',
    children: otherBillTypeManageJurisdiction
  },
  {
    id: '002008000',
    label: '租金管理',
    routerName: 'other-rent-management',
    children: rentManagementJurisdiction
  },
  {
    id: '002009000',
    label: '物业费管理',
    routerName: 'property-management',
    children: propertyManagementJurisdiction
  },
  {
    id: '002010000',
    label: '保证金及其他管理',
    routerName: 'deposit-management',
    children: depositManagementJurisdiction
  },
  {
    id: '002003000',
    label: '操作日志',
    routerName: 'investment-leasing-log',
    children: []
  }
]

const investmentLeasingJurisdiction = {
  id: '002',
  label: '智慧合约',
  routerName: '',
  children: investmentLeasingJurisdictionChildren
}

export { investmentLeasingJurisdiction }



// WEBPACK FOOTER //
// ./src/utils/jurisdiction/investmentLeasingJurisdiction.js